import script from "./HeaderNotificationsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotificationsModal.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNotificationsModal.vue?vue&type=style&index=0&id=a06820e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a06820e0"]])

export default __exports__